function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import useResizeObserver from 'use-resize-observer/polyfilled';
import ErrorSevere from './Icons/ErrorSevere';
import Info from './Icons/Info';
import WarningImportant from './Icons/WarningImportant';
import TickCircle from './Icons/TickCircle';
import Button from './Buttons/Button';
import ArrowLink from './Links/ArrowLink';
import { padding, margin, font, size, px2rem } from '../utils/helpers';
var Container = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  var alert = theme.alert,
      colors = theme.colors;
  var container = alert.container;
  var backgroundColor;

  switch (variant) {
    case 'error':
      backgroundColor = colors.functionalDimmedError;
      break;

    case 'info':
      backgroundColor = colors.functionalDimmedInfo;
      break;

    case 'alert':
      backgroundColor = colors.functionalDimmedAlert;
      break;

    case 'success':
    default:
      backgroundColor = colors.functionalDimmedSuccess;
  }

  return _extends({}, padding(container.shared), {
    backgroundColor: backgroundColor
  });
});
var Content = styled.div(_templateObject2(), function (_ref2) {
  var theme = _ref2.theme,
      isMini = _ref2.isMini,
      hasNegativeMargin = _ref2.hasNegativeMargin,
      hasLink = _ref2.hasLink,
      hasContent = _ref2.hasContent;
  var alert = theme.alert;
  var container = alert.container,
      titleContainer = alert.titleContainer,
      icon = alert.icon,
      title = alert.title;
  var marginObj = {};

  if (hasNegativeMargin) {
    if (hasLink && !hasContent) {
      marginObj.marginTop = titleContainer.hasPadding.hasLinkWithoutContent.paddingBottom - title.standard.hasPadding.paddingBottom;
    } else if (hasContent === 1) {
      marginObj.marginTop = titleContainer.hasPadding.hasContent.paddingBottom - title.standard.hasPadding.paddingBottom;
    } else if (hasContent > 1) {
      marginObj.marginTop = titleContainer.hasPadding.hasContentMultiple.paddingBottom - title.standard.hasPadding.paddingBottom;
    }
  } else if (isMini) {
    marginObj.marginTop = -title.mini.paddingBottom;
  }

  return _extends({}, margin(_extends({}, marginObj, {
    marginLeft: container.shared.paddingLeft + (!isMini ? icon.standard.size : icon.mini.size)
  })));
});
var TitleContainer = styled.div(_templateObject3(), function (_ref3) {
  var theme = _ref3.theme,
      hasPadding = _ref3.hasPadding,
      hasLink = _ref3.hasLink,
      hasContent = _ref3.hasContent;
  var alert = theme.alert;
  var titleContainer = alert.titleContainer,
      icon = alert.icon;
  var paddingObj = {};

  if (hasPadding) {
    paddingObj = titleContainer.hasPadding;

    if (hasLink && !hasContent) {
      paddingObj = _extends({}, titleContainer.hasPadding, titleContainer.hasPadding.hasLinkWithoutContent);
    } else if (hasContent === 1) {
      paddingObj = _extends({}, titleContainer.hasPadding, titleContainer.hasPadding.hasContent);
    } else if (hasContent > 1) {
      paddingObj = _extends({}, titleContainer.hasPadding, titleContainer.hasPadding.hasContentMultiple);
    }
  }

  return _extends({
    display: 'flex',
    alignItems: 'center'
  }, padding(paddingObj), {
    svg: _extends({}, margin(icon.shared))
  });
});
var Title = styled.p(_templateObject4(), function (_ref4) {
  var theme = _ref4.theme,
      isMini = _ref4.isMini,
      hasPadding = _ref4.hasPadding,
      hasNegativeMargin = _ref4.hasNegativeMargin;
  var colors = theme.colors,
      text = theme.text,
      alert = theme.alert;
  var title = alert.title;
  var shared = title.shared,
      standard = title.standard,
      mini = title.mini;
  var paddingObj = {};
  var marginObj = {};

  if (hasPadding) {
    paddingObj = standard.hasPadding;
  } else if (isMini) {
    paddingObj = mini;
  }

  if (hasNegativeMargin) {
    marginObj = standard.hasNegativeMargin;
  }

  return _extends({
    flex: '1 1 0rem'
  }, font({
    fontFamily: text.shared.bold.fontFamily,
    fontWeight: text.shared.bold.fontWeight,
    fontSize: !isMini ? text.standard.xlarge.fontSize : text.mention.xlarge.fontSize,
    lineHeight: !isMini ? text.standard.xlarge.lineHeight : text.mention.xlarge.lineHeight
  }), {
    maxWidth: shared.maxWidth,
    color: colors.black,
    margin: 0
  }, padding(paddingObj), margin(marginObj));
});
var ButtonRight = styled(Button)(_templateObject5(), function (_ref5) {
  var theme = _ref5.theme;
  var alert = theme.alert;
  var button = alert.button;
  return _extends({}, margin(button.right));
});
var AlertText = styled.div(_templateObject6(), function (_ref6) {
  var theme = _ref6.theme,
      isMini = _ref6.isMini,
      hasLink = _ref6.hasLink;
  var colors = theme.colors,
      text = theme.text,
      alert = theme.alert;
  var alertText = alert.text;
  var shared = alertText.shared,
      standard = alertText.standard,
      mini = alertText.mini;
  var paddingObj = {};

  if (!isMini) {
    if (!hasLink) {
      paddingObj = standard;
    } else {
      paddingObj = standard.hasLink;
    }
  } else {
    paddingObj = mini;
  }

  return _extends({}, font({
    fontFamily: text.shared.normal.fontFamily,
    fontWeight: text.shared.normal.fontWeight,
    fontSize: !isMini ? text.standard.xlarge.fontSize : text.mention.xlarge.fontSize,
    lineHeight: !isMini ? text.standard.xlarge.lineHeight : text.mention.xlarge.lineHeight
  }), {
    maxWidth: shared.maxWidth,
    color: colors.black
  }, padding(paddingObj));
});
var ListAlertText = styled.ul(_templateObject7(), function (_ref7) {
  var theme = _ref7.theme,
      hasLink = _ref7.hasLink;
  var alert = theme.alert;
  var textList = alert.textList;
  return _extends({
    margin: 0
  }, padding(!hasLink ? textList : textList.hasLink), {
    listStyle: 'none'
  });
});
var ListAlertTextItem = styled.li(_templateObject8(), function (_ref8) {
  var theme = _ref8.theme;
  var text = theme.text,
      alert = theme.alert;
  var textListItem = alert.textListItem;
  return _extends({
    position: 'relative'
  }, padding(textListItem), font(_extends({}, text.shared.normal, text.standard.xlarge)), {
    '::before': _extends({
      content: '""'
    }, size(textListItem.bullet), {
      backgroundColor: 'black',
      borderRadius: '50%',
      display: 'inline-block',
      position: 'absolute',
      top: px2rem(textListItem.bullet.offsetTop),
      left: 0
    }),
    '&:not(:last-child)': _extends({}, margin(textListItem))
  });
});

function Alert(props) {
  var id = props.id,
      theme = props.theme,
      mini = props.mini,
      variant = props.variant,
      title = props.title,
      content = props.content,
      button = props.button,
      buttonPosition = props.buttonPosition,
      link = props.link,
      href = props.href,
      onClick = props.onClick,
      contentDisplayed = props.contentDisplayed,
      forwardedButtonProps = props.forwardedButtonProps,
      forwardedLinkProps = props.forwardedLinkProps,
      rest = _objectWithoutPropertiesLoose(props, ["id", "theme", "mini", "variant", "title", "content", "button", "buttonPosition", "link", "href", "onClick", "contentDisplayed", "forwardedButtonProps", "forwardedLinkProps"]);

  var _useResizeObserver = useResizeObserver(),
      titleRef = _useResizeObserver.ref,
      titleHeight = _useResizeObserver.height;

  var rightButtonEl = useRef(null);
  var alert = theme.alert;
  var icon;
  var iconColor;
  var backgroundType;

  switch (variant) {
    case 'error':
      icon = ErrorSevere;
      iconColor = 'functionalError';
      backgroundType = 'functionalDimmedError';
      break;

    case 'info':
      icon = Info;
      iconColor = 'functionalInfo';
      backgroundType = 'functionalDimmedInfo';
      break;

    case 'alert':
      icon = WarningImportant;
      iconColor = 'functionalAlert';
      backgroundType = 'functionalDimmedAlert';
      break;

    case 'success':
    default:
      icon = TickCircle;
      iconColor = 'functionalSuccess';
      backgroundType = 'functionalDimmedSuccess';
  }

  var titleHasPadding;

  if (!mini) {
    if (buttonPosition === 'bottom') {
      titleHasPadding = titleHeight < alert.icon.standard.size;
    } else if (buttonPosition === 'right' && rightButtonEl.current !== null) {
      var _rightButtonEl$curren = rightButtonEl.current.getBoundingClientRect(),
          height = _rightButtonEl$curren.height;

      titleHasPadding = titleHeight > height;
    }
  } else {
    titleHasPadding = false;
  }

  var titleContainerHasPadding = titleHeight >= (!mini ? alert.icon.standard.size : alert.icon.mini.size) && buttonPosition !== 'right' && !mini;
  var hasLink = link !== undefined;
  var hasButton = button !== undefined;
  var hasContent = content !== undefined ? content.length : 0;
  return /*#__PURE__*/React.createElement(Container, _extends({
    id: id,
    variant: variant
  }, rest), /*#__PURE__*/React.createElement(TitleContainer, {
    hasPadding: titleContainerHasPadding,
    hasLink: hasLink,
    hasContent: hasContent
  }, React.createElement(icon, {
    id: id + "-icon-" + variant,
    size: !mini ? alert.icon.standard.size : alert.icon.mini.size,
    color: iconColor
  }), /*#__PURE__*/React.createElement(Title, {
    id: id + "-title-" + variant,
    ref: titleRef,
    isMini: mini,
    hasPadding: titleHasPadding,
    hasNegativeMargin: !titleHasPadding && buttonPosition === 'right'
  }, title), hasButton && !mini && buttonPosition === 'right' && /*#__PURE__*/React.createElement(ButtonRight, _extends({
    as: href && 'a',
    variant: "wired",
    backgroundType: backgroundType,
    onClick: onClick,
    href: href,
    ref: rightButtonEl
  }, forwardedButtonProps), button)), (content || button || link) && /*#__PURE__*/React.createElement(Content, {
    isMini: mini,
    hasNegativeMargin: titleHasPadding,
    hasLink: hasLink,
    hasContent: hasContent
  }, hasLink && mini && /*#__PURE__*/React.createElement(ArrowLink, _extends({
    href: href,
    mini: true,
    variant: content === undefined && 'next' || !contentDisplayed && 'down' || 'up',
    background: backgroundType,
    onClick: onClick
  }, forwardedLinkProps), link), content && (contentDisplayed || !mini) && content.length === 1 &&
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React.createElement(AlertText, {
    isMini: mini,
    hasLink: hasLink
  }, content[0]), content && (contentDisplayed || !mini) && content.length > 1 && /*#__PURE__*/React.createElement(ListAlertText, {
    hasLink: hasLink
  }, content.map(function (contentText, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(ListAlertTextItem, {
        key: index,
        hasLink: hasLink
      }, contentText)
    );
  })), hasButton && !hasLink && !mini && buttonPosition === 'bottom' && /*#__PURE__*/React.createElement(Button, _extends({
    as: href && 'a',
    variant: "wired",
    backgroundType: backgroundType,
    mb: hasContent <= 1 ? alert.button.bottom.mb : alert.button.bottom.hasContentMultiple.mb,
    onClick: onClick,
    href: href
  }, forwardedButtonProps), button), hasLink && !hasButton && !mini && /*#__PURE__*/React.createElement(ArrowLink, _extends({
    href: href,
    variant: "next",
    background: backgroundType,
    onClick: onClick,
    mb: hasContent <= 1 ? alert.link.standard.mb : alert.link.hasContentMultiple.mb
  }, forwardedLinkProps), link)));
}

Alert.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['error', 'info', 'alert', 'success']),
  title: PropTypes.node.isRequired,
  content: PropTypes.arrayOf(PropTypes.node),
  button: PropTypes.string,
  buttonPosition: PropTypes.oneOf(['bottom', 'right']),
  onClick: PropTypes.func,
  link: PropTypes.string,
  href: PropTypes.string,
  forwardedButtonProps: PropTypes.shape({}),
  forwardedLinkProps: PropTypes.shape({}),
  mini: PropTypes.bool,
  contentDisplayed: PropTypes.bool
} : {};
Alert.defaultProps = {
  variant: 'success',
  content: undefined,
  button: undefined,
  buttonPosition: 'bottom',
  onClick: undefined,
  link: undefined,
  href: undefined,
  forwardedButtonProps: undefined,
  forwardedLinkProps: undefined,
  mini: false,
  contentDisplayed: false
};
export default withTheme(Alert);